import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

export const Toolbar = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${theme.spaceUnit.md};
    margin-bottom: ${theme.spaceUnit.md};
  `
);

export const SearchBox = styled.div`
  flex: 1;
  min-width: 260px;
  max-width: 520px;
`;

export const Control = styled.label(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.spaceUnit.xs};
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;

    select {
      font: inherit;
      padding: 4px 8px;
      border: 1px solid ${theme.colors.grey.grey50};
      border-radius: 8px;
      background: ${theme.colors.white};
      cursor: pointer;
    }
  `
);

export const Summary = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${theme.spaceUnit.sm};
    margin-bottom: ${theme.spaceUnit.sm};
    color: ${theme.colors.grey.grey100};
    font-size: 14px;
  `
);

export const FilterChip = styled.span(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.spaceUnit.xs};
    padding: 2px 4px 2px 10px;
    border-radius: 12px;
    background: ${theme.colors.grey.grey25};
    color: ${theme.colors.black};

    button {
      border: none;
      background: none;
      cursor: pointer;
      font-size: 16px;
      line-height: 1;
      padding: 0 6px;
    }
  `
);

export const MachineLink = styled(Link)(
  ({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: 600;

    :hover {
      text-decoration: underline;
    }
  `
);

export const OutletCell = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${theme.spaceUnit.xs};
    white-space: normal;
  `
);

export const OutletButton = styled.button(
  ({ theme }) => css`
    border: none;
    background: none;
    padding: 0;
    color: ${theme.colors.black};
    font: inherit;
    text-align: left;
    cursor: pointer;

    :hover {
      text-decoration: underline;
    }
  `
);

export const Badge = styled.span<{ tone?: "warning" | "neutral" }>(
  ({ theme, tone = "neutral" }) => css`
    display: inline-block;
    padding: 0 8px;
    border-radius: 10px;
    font-size: 12px;
    line-height: 18px;
    white-space: nowrap;
    background: ${tone === "warning" ? theme.colors.warning.warning25 : theme.colors.grey.grey25};
    color: ${theme.colors.black};
  `
);

export const Muted = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.grey.grey100};
  `
);

export const StatusIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ViewSwitchGroup = styled.div(
  ({ theme }) => css`
    display: inline-flex;
    border: 1px solid ${theme.colors.black};
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: ${theme.spaceUnit.md};
  `
);

export const ViewSwitchLink = styled(Link)<{ selected: boolean }>(
  ({ theme, selected }) => css`
    min-width: 96px;
    padding: ${theme.spaceUnit.xs} ${theme.spaceUnit.md};
    text-align: center;
    font-size: 14px;
    background: ${selected ? theme.colors.black : theme.colors.white};
    color: ${selected ? theme.colors.white : theme.colors.black};

    & + & {
      border-left: 1px solid ${theme.colors.black};
    }
  `
);
